import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PRODUCT } from '../../../constants/queryKeys';
import produce from 'immer';
import {
  MINIMUM_PRICE_2000_WON_CATEGORY_NAME_LIST,
  MINIMUM_PRICE_9900_WON_CATEGORY_PRICE,
  PRODUCT_MINIMUM_PRICE,
} from '../../../constants/service/app/productConstants';

const useSelectCategoryMutate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (name) => {
      queryClient.setQueryData([...PRODUCT.PRODUCT_DETAIL], (prev) => {
        return produce(prev, (draft) => {
          draft.productDetail.proCategory.minimumPrice = MINIMUM_PRICE_2000_WON_CATEGORY_NAME_LIST.includes(name)
            ? PRODUCT_MINIMUM_PRICE
            : MINIMUM_PRICE_9900_WON_CATEGORY_PRICE;
        });
      });
    },
  });
};

export default useSelectCategoryMutate;
